import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface AddTagsToParentResponse {
  tags: Array<Tag>;
}

export interface Tag {
  _id: string;
  fieldName: string;
}

export interface AddTagsToParentParams {
  parentId: string;
  tagIds: Array<string>;
}

export const addTagsToParentAPI = async ({
  parentId,
  tagIds,
}: AddTagsToParentParams) => {
  const resp = await baseAPI.post<AddTagsToParentResponse>(
    `/parents/${parentId}/tags`,
    {
      tagIds,
    },
  );
  return resp.data;
};

export const useAddTagsToParentMutation = () => {
  return useMutation({
    mutationFn: async (params: AddTagsToParentParams) => {
      const response = await addTagsToParentAPI(params);
      return response;
    },
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENT_TAGS, params.parentId],
      });
    },
  });
};
